export function unMaskedCreditCardNumber(cardNumber) {
    let numStr = String(cardNumber);

    numStr = numStr.replace(/[\s-]/g, '');

    const formattedNumber = numStr.match(/.{1,4}/g);
    if (formattedNumber) {
        return formattedNumber.join(' ');
    } else {
        return '';
    }
}
export function maskCreditCardNumber(cardNumber, visibleStartCount = 6, visibleEndCount = 4) {
    const maskChar = '•'
    let cleanNumber = String(cardNumber).replace(/\D/g, '');

    if (cleanNumber.length < (visibleStartCount + visibleEndCount) || !/^\d+$/.test(cleanNumber)) {
        console.warn("Внимание: Номер карты слишком короткий или содержит нецифровые символы для маскировки.");
        return unMaskedCreditCardNumber(cardNumber);
    }

    const totalLength = cleanNumber.length;
    const maskedLength = totalLength - visibleStartCount - visibleEndCount;

    if (maskedLength <= 0) {
        return unMaskedCreditCardNumber(cardNumber);
    }

    const startPart = cleanNumber.substring(0, visibleStartCount);
    const endPart = cleanNumber.substring(totalLength - visibleEndCount);

    const maskedPart = maskChar.repeat(maskedLength);

    const fullMaskedNumber = startPart + maskedPart + endPart;

    return fullMaskedNumber.replace(/(\S{4})(?=\S)/g, '$1 ');
}

export function maskExpiredDate(expiredString) {
    const maskChar = '•';
    let cleanNumber = String(expiredString).replace(/\D/g, '');

    // Handle the common "MM/YY" format
    if (cleanNumber.length <= 2) { // Only month entered or partial
        return cleanNumber.replace(/./g, maskChar);
    } else if (cleanNumber.length > 2 && cleanNumber.length <= 4) { // Month and partial/full year
        // Mask month, then add '/', then mask year
        const maskedMonth = cleanNumber.substring(0, 2).replace(/./g, maskChar);
        const maskedYear = cleanNumber.substring(2).replace(/./g, maskChar);
        return `${maskedMonth}/${maskedYear}`;
    } else { // More than 4 digits, likely invalid or excess
        // Mask everything as a fallback
        return expiredString.replace(/[^/]/g, maskChar);
    }
}

export function maskAllCharacters(str, maskChar = '•') {
    return String(str).replace(/./g, maskChar);
}